/** @jsx jsx */
import React from "react"
import {jsx} from "theme-ui"

export const Complaint = ({ children, href }) => <div sx={{fontWeight: 'bold', fontSize: 4}}>
  <a target="_blank" rel="noreferrer" href={href}>{children}</a>
  <hr/>
</div>